module.exports = __webpack_public_path__ + "img/eth-towers.dd7a9f08.jpg";